
import Vue from "vue";
import Component from "vue-class-component";

@Component<Title>({})
export default class Title extends Vue {}
